import {useMutation} from '@apollo/client';
import {useCallback, useState} from 'react';
import {
    APPROVE_REVIEW_TASK,
    ApproveReviewTaskMutationResponse,
    REJECT_REVIEW_TASK,
    RejectReviewTaskMutationResponse,
    ReviewTaskActionMutationVariables,
} from '../graphql/mutations/reviewTaskMutations';
import {ReviewTaskListItem} from '../graphql/types/ReviewTaskType';

export const useReviewTaskActions = () => {
    const [loading, setLoading] = useState(false);
    const [approveMutation] = useMutation<
        ApproveReviewTaskMutationResponse,
        ReviewTaskActionMutationVariables
    >(APPROVE_REVIEW_TASK);
    const [rejectMutation] = useMutation<
        RejectReviewTaskMutationResponse,
        ReviewTaskActionMutationVariables
    >(REJECT_REVIEW_TASK);

    /** 审核通过；commentJson 是结构化 JSON 字符串 */
    const approve = useCallback(
        async (reviewTaskId: number, commentJson?: string | null): Promise<ReviewTaskListItem> => {
            setLoading(true);
            try {
                const {data, errors} = await approveMutation({
                    variables: {reviewTaskId, commentJson: commentJson ?? null},
                });
                if (errors && errors.length > 0) {
                    throw new Error(errors[0].message);
                }
                if (!data?.approveReviewTask) {
                    throw new Error('approveReviewTask mutation returned empty result');
                }
                return data.approveReviewTask;
            } finally {
                setLoading(false);
            }
        },
        [approveMutation]
    );

    /** 审核驳回；commentJson 是结构化 JSON 字符串 */
    const reject = useCallback(
        async (reviewTaskId: number, commentJson?: string | null): Promise<ReviewTaskListItem> => {
            setLoading(true);
            try {
                const {data, errors} = await rejectMutation({
                    variables: {reviewTaskId, commentJson: commentJson ?? null},
                });
                if (errors && errors.length > 0) {
                    throw new Error(errors[0].message);
                }
                if (!data?.rejectReviewTask) {
                    throw new Error('rejectReviewTask mutation returned empty result');
                }
                return data.rejectReviewTask;
            } finally {
                setLoading(false);
            }
        },
        [rejectMutation]
    );

    return {
        approve,
        reject,
        loading,
    };
};
